import React, { useState } from 'react'
import Navbar from './Navbar';
import Footer from './Footer'
import data from './../data'

function Card() {



    const [menudata, setmenudata] = useState(data);
    const filteritem = (country) => {
        const updatedlist = data.filter((curElm) => {
            return curElm.country === country;
        })
        setmenudata(updatedlist)
    }

    return (
        <>
            <Navbar />

            <nav class="relative w-full flex flex-wrap items-center justify-between py-3 bg-gray-100 text-gray-500 hover:text-gray-700 focus:text-gray-700 shadow-lg">
                <div class="container-fluid w-full flex flex-wrap items-center justify-between ">
                    <div class="container-fluid">
                        <ul className="px-16 flex flex-row justify-start space-x-3 lg:justify-start my-2 md:text-3xl md:space-x-5 md:font-light lg:text-lg hover:underline font-serif">
                            <span className='font-extrabold text-gray-700 px-5 no-underline'>Top News </span>
                            <li>
                                <button className='hover:text-blue-500' onClick={() => filteritem("us")} style={{ "WebkitTapHighlightColor": "transparent" }}>us</button>
                            </li>
                            <li>
                                <button className='hover:text-blue-500' onClick={() => filteritem("uk")} style={{ "WebkitTapHighlightColor": "transparent" }}>uk</button>
                            </li>
                            <li>
                                <button className='hover:text-blue-500' onClick={() => filteritem("fr")} style={{ "WebkitTapHighlightColor": "transparent" }}>France</button>
                            </li>
                            <li>
                                <button className='hover:text-blue-500' onClick={() => filteritem("au")} style={{ "WebkitTapHighlightColor": "transparent" }}>Australia</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            {menudata.map((article) => (
                <div key={article.url} id='1'>
                    <section class="text-gray-600 body-font overflow-hidden ">
                        <div class="container px-5 py-24 mx-auto ">
                            <div class="-my-8 divide-y-2 divide-gray-100">
                                <div class="py-8 flex flex-wrap md:flex-nowrap">
                                    <div class="md:w-64 md:mb-0 mb-6 flex-shrink-0 flex flex-col px-5">
                                        <img src={article.urlToImage} alt="" />
                                        <span class="font-semibold title-font text-gray-700 mt-3">{article.author}</span>
                                        <span class="mt-1 text-gray-500 text-sm">{article.publishedAt}</span>
                                    </div>
                                    <div class="md:flex-grow">
                                        <h2 class="text-2xl font-medium text-gray-900 title-font mb-2">{article.title}</h2>
                                        <p class="leading-relaxed">{article.description}</p>
                                        <a class="text-blue-500 font-bold inline-flex items-center mt-4" href={article.url} >Learn More
                                            <svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M5 12h14"></path>
                                                <path d="M12 5l7 7-7 7"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            ))}

            <Footer />

        </>
    )
}

export default Card;